import { transport } from 'config/transport';

export function callApiSaveAllDuThu(congDoanId, gradeId, body) {
    return transport.post(`/mamnon/${congDoanId}/thuhocsinh/${gradeId}/duthu`, body);
}
